/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { DEFAULT_COLUMN_KEYS, DEFAULT_COLUMN_KEYS_SORT_LIST, COLUMN_KEYS } from '../constants';
import { fetchReportsAggsColumnSettings, postReportsAggsColumnSettings } from '../../../api/reportsaggscolumnsettings';
import { selectColumnKeys, selectColumnKeysSortList } from '../selectors';
import {
  setSettings,
  setIsLoadingLoaded,
  clear,
  resetToDefaults,
  enableColumn,
  disableColumn,
  toggleColumn,
  moveColumnSort
} from './actions';

const isEmpty = obj => {
  if (obj instanceof Array) {
    return obj.length === 0;
  }

  if (typeof obj === 'object') { 
    return Object.keys(obj).length === 0;
  }

  return !obj;
}

const cleanColumnKeysMap = (map) => { 
  return Object.keys((map || {})).reduce((acc, key) => { 
    if (COLUMN_KEYS[key]) {
      acc[key] = COLUMN_KEYS[key];
    }
    return acc;
  }, {})
}

const cleanColumnKeysArray = (arr) => { 
  return (arr || []).filter(key => COLUMN_KEYS[key]);
}

const thunkLoad = () => (dispatch) => {
  dispatch(clear());
	dispatch(
		setIsLoadingLoaded({
			isLoading: true,
			isLoaded: false
		})
	);
  fetchReportsAggsColumnSettings().then((res) => {
    if (!isEmpty(res)) { 
      const { columnKeys, columnKeysSortList } = res;
      dispatch(
        setSettings(
          cleanColumnKeysMap(columnKeys || {...DEFAULT_COLUMN_KEYS}),
          cleanColumnKeysArray(columnKeysSortList || [...DEFAULT_COLUMN_KEYS_SORT_LIST])      
        )
      );
    }
		dispatch(
			setIsLoadingLoaded({
				isLoading: false,
				isLoaded: true
			})
		);
	});
};

const thunkSave = () => (_dispatch, getState) => {
  const columnKeys = selectColumnKeys(getState());
  const columnKeysSortList = selectColumnKeysSortList(getState());
  postReportsAggsColumnSettings(columnKeys, columnKeysSortList);
};

const thunkEnableColumn = (key) => (dispatch) => {
  dispatch(enableColumn(key));
  dispatch(thunkSave());
};

const thunkDisableColumn = (key) => (dispatch) => { 
  dispatch(disableColumn(key));
  dispatch(thunkSave());
};

const thunkToggleColumn = (key) => (dispatch) => { 
  dispatch(toggleColumn(key));
  dispatch(thunkSave());
};

const thunkMoveColumnSort = (key, toIdx) => (dispatch) => { 
  dispatch(moveColumnSort(key, toIdx));
  dispatch(thunkSave());
};

const thunkResetToDefaults = () => (dispatch) => { 
  dispatch(resetToDefaults());
  dispatch(thunkSave());
}



export {
  thunkLoad,
  thunkSave,

  thunkResetToDefaults,

  thunkEnableColumn,
  thunkDisableColumn,
  thunkToggleColumn,
  thunkMoveColumnSort
};
